module.exports = __webpack_public_path__ + "static/media/marialuz.a01e683f.jpg";